import { Component, Inject, computed } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MceSaveCancelComponent } from '../../components/mce-save-cancel/mce-save-cancel.component';
import { MceSaveCancelEvent } from '../../components/mce-save-cancel/mce-save-cancel.component';
import { MceSaveCancelConfig } from '../../components/mce-save-cancel/mce-save-cancel.component';

@Component({
    selector: 'app-dialog-acknowledge',
    imports: [MatButtonModule, MceSaveCancelComponent, MatDialogModule],
    templateUrl: './acknowledge.component.html'
})
export class AcknowledgeComponent {
  readonly saveCancelConfig = computed<MceSaveCancelConfig>(() => ({
    ok: { show: true, enable: true }
  }));

  constructor(
    public dialogRef: MatDialogRef<AcknowledgeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string, message: string }
  ) { }

  get title(): string {
    return this.data.title;
  }

  get message(): string {
    return this.data.message;
  }

  onOK(): void {
    this.dialogRef.close(true);
  }

  onSaveCancelAction(event: MceSaveCancelEvent): void {
    if (event.type === 'ok') {
      this.onOK();
    }
  }


}
